import { render, staticRenderFns } from "./copy-declare-group.vue?vue&type=template&id=149b5a6d&scoped=true"
import script from "./copy-declare-group.vue?vue&type=script&lang=ts"
export * from "./copy-declare-group.vue?vue&type=script&lang=ts"
import style0 from "./copy-declare-group.vue?vue&type=style&index=0&id=149b5a6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b5a6d",
  null
  
)

export default component.exports